import { SearchResult } from 'Core/interfaces'

import { TaxRate } from './TaxCategory'

export enum LocalitySearchResultFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByCode = 'searchByCode',
	searchByCountyCode = 'searchByCountyCode'
}

export enum LocalityFilterFields {
	includeInactive = 'includeInactive',
	countryId = 'countryId',
	stateId = 'stateId'
}

export enum LocalityFormFields {
	code = 'code',
	name = 'name',
	description = 'description',
	taxCorporationCode = 'taxCorporationCode',
	revenueAccountCode = 'revenueAccountCode',
	revenueTaxAccountCode = 'revenueTaxAccountCode',
	expenseTaxAccountCode = 'expenseTaxAccountCode',
	rebateTaxAccountCode = 'rebateTaxAccountCode',
	rebateRevenueAccountCode = 'rebateRevenueAccountCode',
	rebateExpenseAccountCode = 'rebateExpenseAccountCode',

	countryId = 'countryId',
	countyId = 'countyId',
	stateProvinceId = 'stateProvinceId',
	taxRates = 'taxRates',

	isActive = 'isActive',
	isRetencion = 'isRetencion'
}

export interface SearchByCode extends IdCode {}

export interface SearchByCountryCode extends IdCode {}

export declare namespace Locality {
	interface Basic extends CodeEntity {
		countryCode: string
		stateAbbreviation: string | null
		countyName: string | null
		isActive: boolean
	}

	interface Detailed {
		id: number
		name: string
		code: string
		taxCorporationCode: NameCode | null
		description: string
		country: {
			id: number
			code: string
		}
		county: Entity | null
		stateProvince: Entity | null
		revenueAccountCode: string
		revenueTaxAccountCode: string
		expenseTaxAccountCode: string
		rebateTaxAccountCode: string
		rebateRevenueAccountCode: string
		rebateExpenseAccountCode: string
		taxRates: TaxRate.Detailed[]
		isActive: boolean
		isRetencion: boolean
	}

	namespace Form {
		interface Generic {
			[LocalityFormFields.code]: string
			[LocalityFormFields.name]: string
			[LocalityFormFields.description]: string
			[LocalityFormFields.taxCorporationCode]: string | null
			[LocalityFormFields.revenueAccountCode]: string
			[LocalityFormFields.revenueTaxAccountCode]: string
			[LocalityFormFields.expenseTaxAccountCode]: string
			[LocalityFormFields.rebateTaxAccountCode]: string
			[LocalityFormFields.rebateRevenueAccountCode]: string
			[LocalityFormFields.rebateExpenseAccountCode]: string

			[LocalityFormFields.countryId]: number | null
			[LocalityFormFields.countyId]: number | null
			[LocalityFormFields.stateProvinceId]: number | null

			[LocalityFormFields.taxRates]: TaxRate.Form.Generic[]

			[LocalityFormFields.isActive]: boolean
			[LocalityFormFields.isRetencion]: boolean
		}
	}

	namespace Request {
		interface Generic extends Omit<Form.Generic, 'taxRates'> {
			[LocalityFormFields.taxRates]: TaxRate.Request.Generic[]
		}
	}

	namespace Search {
		interface Result extends SearchResult {
			searchByCode: IdCode[]
			searchByCountyCode: IdCodeName[]
		}
	}
}
